import type {Agent} from "@atproto/api";

export class AtpClientError extends Error {
  lexicon: string;
  action: string;

  constructor(lexicon: string, action: string, message?: string) {
    super(`${action}(${lexicon}): ${message}`);
    this.name = "AtpClientError";
    this.lexicon = lexicon;
    this.action = action;
  }
}

/**
 * Uploads a media blob (e.g., SVG stroke image) to the PDS.
 *
 * @param agent - The authenticated ATProto agent.
 * @param blob - The file or binary data to upload.
 * @returns The blob reference metadata.
 */
export async function uploadBlob(agent: Agent, blob: Blob | Uint8Array) {
  // The API expects Uint8Array for uploads in browser context usually,
  // or Blob if handled by fetch.
  // @atproto/api uploadBlob accepts Uint8Array or Blob (in browser).
  const {data} = await agent.uploadBlob(blob, {encoding: "image/svg+xml"});
  return data.blob;
}
